/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  GetCurrentBpTpResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get current running Bp TP
 */
export const getBpTpCurrent = (signal?: AbortSignal) => {
  return customInstance<GetCurrentBpTpResponseResponse>({
    url: `/bm-declaration-service/v1/bp-tp/current`,
    method: 'get',
    signal,
  });
};

export const getGetBpTpCurrentQueryKey = () => {
  return [`/bm-declaration-service/v1/bp-tp/current`] as const;
};

export const getGetBpTpCurrentQueryOptions = <
  TData = Awaited<ReturnType<typeof getBpTpCurrent>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBpTpCurrent>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBpTpCurrentQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBpTpCurrent>>> = ({ signal }) =>
    getBpTpCurrent(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBpTpCurrent>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBpTpCurrentQueryResult = NonNullable<Awaited<ReturnType<typeof getBpTpCurrent>>>;
export type GetBpTpCurrentQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Get current running Bp TP
 */
export const useGetBpTpCurrent = <
  TData = Awaited<ReturnType<typeof getBpTpCurrent>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBpTpCurrent>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBpTpCurrentQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
